/**
 * Trust & Credibility Data
 * Client logos, testimonials, and trust indicators for enhanced credibility
 */

// Client Logos - Removed placeholder content
// Real client logos will be added when available
export const CLIENT_LOGO_DATA = [];

// Client Testimonials - Removed placeholder content
// Real client testimonials will be added when available
export const CLIENT_TESTIMONIALS = [];

// Trust Indicators & Certifications - Removed potentially fake claims
// Real certifications will be added when verified
export const TRUST_INDICATORS = [];

// Success Metrics & Statistics - Removed exaggerated claims
// Real metrics will be added when available
export const SUCCESS_METRICS = [];

// Industry Recognition & Awards - Removed unverifiable claims
// These awards had no issuing-body links or public verification. Re-add only with
// a verifiable `sourceUrl` so the UI can link out to proof.
export const INDUSTRY_RECOGNITION = [];

// Security & Compliance Details
export const SECURITY_COMPLIANCE = [
  {
    id: 'data-security',
    title: 'Enterprise-Grade Security',
    description: 'Multi-layered security architecture with end-to-end encryption',
    features: [
      '256-bit SSL encryption',
      'Multi-factor authentication',
      'Regular security audits',
      'Penetration testing'
    ]
  },
  {
    id: 'data-privacy',
    title: 'Privacy-First Approach',
    description: 'GDPR, CCPA, and local privacy law compliance',
    features: [
      'Data minimization principles',
      'Right to be forgotten',
      'Consent management',
      'Privacy impact assessments'
    ]
  },
  {
    id: 'business-continuity',
    title: 'Business Continuity',
    description: '99.9% uptime with disaster recovery capabilities',
    features: [
      'Redundant infrastructure',
      'Automated backups',
      'Disaster recovery plans',
      '24/7 monitoring'
    ]
  }
];

// Partnership & Alliance Data - Removed placeholder content
// Real partnerships will be added when verified
export const PARTNERSHIPS = [];

export default {
  CLIENT_LOGO_DATA,
  CLIENT_TESTIMONIALS,
  TRUST_INDICATORS,
  SUCCESS_METRICS,
  INDUSTRY_RECOGNITION,
  SECURITY_COMPLIANCE,
  PARTNERSHIPS
};
